import { getCookie } from './alertCookie';

const jQ = jQuery.noConflict();
const alertOverlay = jQ('.alert__wrapper');
const alertContent = jQ('.alert__container');
const trigger = jQ('.alert__trigger');
const close = jQ('.alert__overlay-close');
const btnClose = jQ('.alert__overlay-inner-close');
const body = jQ('body');
const checker = jQ('.load-checker');

function showMessage() {
    if (alertOverlay.length > 0) {
        alertOverlay.addClass('active');
        alertContent.addClass('active');
        body.addClass('lock-scroll');
    }
}

function hideMessage() {
    alertOverlay.removeClass('active');
    alertContent.removeClass('active');
    body.removeClass('lock-scroll');
}

function loadMessage() {
    if (checker.length > 0) {
        const cookies = getCookie('showAlert');
        if (cookies === '') {
            showMessage();
        }
    }
}
function initMessage() {
    trigger.on('click', () => {
        showMessage();
    });

    close.on('click', () => {
        hideMessage();
    });

    btnClose.on('click', (e) => {
        e.preventDefault();
        hideMessage();
    });
}

export { initMessage, loadMessage };
